import { Button } from "@mui/material";
import ChipsTableCellComponent from "../ChipsTableCell.Component";
import UpdateMrqBtn from "../ChangeOrderBtn/UpdateMrqBtn";
import UpdatePOBtn from "../ChangeOrderBtn/UpdatePoBtn";

// Helper function to find the latest revision with data for unchanged material
const findLatestRevisionWithData = (
  revisions,
  currentIndex,
  tagNumber,
  currentMaterial,
  dataAccessor,
) => {
  const sortedRevs = revisions.sort((a, b) => a.revision - b.revision);

  let hasChanged = false;
  ["description"].forEach((key) => {
    if (currentMaterial[key]) {
      // Check if description changed from any previous revision
      for (let i = currentIndex - 1; i >= 0; i--) {
        const prevMaterial = sortedRevs[i]?.materials?.find(
          (pm) => pm.taggedMaterial?.tagNumber === tagNumber,
        );
        if (prevMaterial && currentMaterial[key] !== prevMaterial[key]) {
          hasChanged = true;
          break;
        }
      }
    }
  });

  // If material hasn't changed, find the latest revision with the data
  if (!hasChanged) {
    for (let i = currentIndex - 1; i >= 0; i--) {
      const material = sortedRevs[i]?.materials?.find(
        (pm) => pm.taggedMaterial?.tagNumber === tagNumber,
      );
      if (material) {
        const data = dataAccessor(material);
        if (data) {
          return data;
        }
      }
    }
  }

  return null;
};

export const drawingMcsDataCols = [
  {
    accessorKey: "mrqNumber",
    header: "MRQ #",
    enableEditing: false,
    size: 90,
    Cell: ({ row }) => {
      let chips =
        row.original.mrqMaterials?.map((m) => {
          return m?.mrq;
        }) || [];

      const revs = row.original.drawingRevs || [];
      const sortedRevs = revs.sort((a, b) => a.revision - b.revision) || [];
      const drawing = row.original.drawing || {};
      const tagNumber = row.original.taggedMaterial?.tagNumber;

      const index = sortedRevs.findIndex((rev) => rev.id === drawing?.id);
      const notRev0 = index > 0;

      // If no current MRQ, check for inherited MRQ from previous revisions
      if (!chips?.[0] && notRev0) {
        const latestMrq = findLatestRevisionWithData(
          sortedRevs,
          index,
          tagNumber,
          row.original,
          (material) => material?.mrqMaterials?.map((m) => m?.mrq) || null,
        );
        if (latestMrq) {
          chips = latestMrq;
        }
      }

      const previousDrawing = index !== 0 ? sortedRevs[index - 1] : {};
      const previousMaterial = previousDrawing?.materials?.find(
        (pm) =>
          (pm.taggedMaterial?.tagNumber || pm.item) ===
          (row.original.taggedMaterial?.tagNumber || row.original.item),
      );

      const hasPreviousMrq =
        previousDrawing?.id && previousMaterial?.mrqMaterials?.[0]?.id
          ? true
          : false;

      console.log("ddddd", previousMaterial, row.original);

      let hasChanged = false;
      ["description", "quantity", "length"].forEach((key) => {
        if (previousMaterial && row.original[key] !== previousMaterial[key]) {
          hasChanged = true;
        }
      });

      return chips?.[0] && !hasChanged ? (
        <ChipsTableCellComponent type="mrq" chips={chips} />
      ) : notRev0 && hasPreviousMrq && hasChanged ? (
        <UpdateMrqBtn
          material={row.original}
          drawing={drawing}
          previousDrawing={previousDrawing}
        />
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "poNumber",
    header: "PO #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      let chips = [];

      row.original.mrqMaterials?.forEach((m) => {
        m.poMaterials?.forEach((pm) => chips.push(pm.po));
      });

      const revs = row.original.drawingRevs || [];
      const sortedRevs = revs.sort((a, b) => a.revision - b.revision);
      const drawing = row.original.drawing || {};
      const tagNumber = row.original.taggedMaterial?.tagNumber;

      const index = sortedRevs.findIndex((rev) => rev.id === drawing?.id);
      const notRev0 = index > 0;

      // If no current PO, check for inherited PO from previous revisions
      if (!chips?.[0] && notRev0) {
        const latestPo = findLatestRevisionWithData(
          sortedRevs,
          index,
          tagNumber,
          row.original,
          (material) => {
            const pos = [];
            material?.mrqMaterials?.forEach((m) => {
              m.poMaterials?.forEach((pm) => pos.push(pm.po));
            });
            return pos.length > 0 ? pos : null;
          },
        );
        if (latestPo) {
          chips = latestPo;
        }
      }

      const previousDrawing = index !== 0 ? sortedRevs[index - 1] : {};
      const previousMaterial = previousDrawing?.materials?.find(
        (pm) =>
          pm.taggedMaterial?.tagNumber ===
          row.original.taggedMaterial?.tagNumber,
      );

      const hasPreviousPo =
        previousDrawing?.id &&
        previousMaterial?.mrqMaterials?.[0]?.poMaterials?.[0]?.id
          ? true
          : false;

      let hasChanged = false;
      ["description"].forEach((key) => {
        if (previousMaterial && row.original[key] !== previousMaterial[key]) {
          hasChanged = true;
        }
      });

      const previousPO = {
        ...previousMaterial?.mrqMaterials?.[0]?.poMaterials?.[0]?.po,
      };

      // console.log("po changessss", previousPO);

      return chips?.[0] ? (
        <ChipsTableCellComponent type="po" chips={chips} />
      ) : notRev0 && hasPreviousPo ? (
        // <UpdatePOBtn
        //   drawing={drawing}
        //   previousPO={previousPO}
        //   previousDrawing={previousDrawing}
        // />
        ""
      ) : (
        ""
      );
    },
  },

  {
    accessorKey: "vendor",
    header: "Vendor",
    enableEditing: false,
    size: 90,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      let vendor =
        row.original.mrqMaterials?.[0]?.poMaterials?.[0]?.vendor?.name || "";

      // If no vendor, check previous drawing revisions for inherited vendor
      if (!vendor) {
        const revs = row.original.drawingRevs || [];
        const sortedRevs = revs.sort((a, b) => a.revision - b.revision);
        const drawing = row.original.drawing || {};
        const index = sortedRevs.findIndex((rev) => rev.id === drawing?.id);
        const tagNumber = row.original.taggedMaterial?.tagNumber;

        if (index > 0) {
          const latestVendor = findLatestRevisionWithData(
            sortedRevs,
            index,
            tagNumber,
            row.original,
            (material) =>
              material?.mrqMaterials?.[0]?.poMaterials?.[0]?.vendor?.name ||
              null,
          );
          if (latestVendor) {
            vendor = latestVendor;
          }
        }
      }

      return vendor;
    },
  },
  {
    accessorKey: "cost",
    header: "Cost($)/Unit",
    enableEditing: false,
    size: 20,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      let cost = row.original.mrqMaterials?.[0]?.poMaterials?.[0]?.cost || "";

      // If no cost, check previous drawing revisions for inherited cost
      if (!cost) {
        const revs = row.original.drawingRevs || [];
        const sortedRevs = revs.sort((a, b) => a.revision - b.revision);
        const drawing = row.original.drawing || {};
        const index = sortedRevs.findIndex((rev) => rev.id === drawing?.id);
        const tagNumber = row.original.taggedMaterial?.tagNumber;

        if (index > 0) {
          const latestCost = findLatestRevisionWithData(
            sortedRevs,
            index,
            tagNumber,
            row.original,
            (material) =>
              material?.mrqMaterials?.[0]?.poMaterials?.[0]?.cost || null,
          );
          if (latestCost) {
            cost = latestCost;
          }
        }
      }

      return cost;
    },
  },
  {
    accessorKey: "schedule",
    header: "Schedule",
    enableEditing: false,
    size: 70,

    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      let date = row.original.mrqMaterials?.[0]?.poMaterials?.[0]?.time;

      // If no schedule, check previous drawing revisions for inherited schedule
      if (!date) {
        const revs = row.original.drawingRevs || [];
        const sortedRevs = revs.sort((a, b) => a.revision - b.revision);
        const drawing = row.original.drawing || {};
        const index = sortedRevs.findIndex((rev) => rev.id === drawing?.id);
        const tagNumber = row.original.taggedMaterial?.tagNumber;

        if (index > 0) {
          const latestDate = findLatestRevisionWithData(
            sortedRevs,
            index,
            tagNumber,
            row.original,
            (material) =>
              material?.mrqMaterials?.[0]?.poMaterials?.[0]?.time || null,
          );
          if (latestDate) {
            date = latestDate;
          }
        }
      }

      return date ? "in " + date + " Days" : "";
    },
  },
  {
    accessorKey: "mrvNumber",
    header: "MRV #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      // console.log({
      //   mrvRow: row.original.mrvMaterials?.map((m) => {
      //     return m.mrv;
      //   }),
      // });

      let chips =
        row.original.mrvMaterials?.map((m) => {
          return m.mrv;
        }) || [];

      const revs = row.original.drawingRevs || [];
      const sortedRevs = revs.sort((a, b) => a.revision - b.revision);
      const drawing = row.original.drawing || {};
      const index = sortedRevs.findIndex((rev) => rev.id === drawing?.id);
      const notRev0 = index > 0;
      const tagNumber = row.original.taggedMaterial?.tagNumber;

      // If no current MRV, check for inherited MRV from previous revisions
      if (!chips?.[0] && notRev0) {
        const latestMrv = findLatestRevisionWithData(
          sortedRevs,
          index,
          tagNumber,
          row.original,
          (material) => material?.mrvMaterials?.map((m) => m.mrv) || null,
        );
        if (latestMrv) {
          chips = latestMrv;
        }
      }

      const previousState = notRev0 && sortedRevs?.[index - 1];

      const previousMaterial = previousState?.materials?.find(
        (pm) =>
          pm.taggedMaterial?.tagNumber ===
          row.original.taggedMaterial?.tagNumber,
      );

      let hasMrvInPreviousState = false;

      if (previousState) {
        hasMrvInPreviousState = previousState?.materials?.some((material) => {
          return (
            material.id === row.original.id && material.mrvMaterials?.length > 0
          );
        });
      }

      // console.log("hasMrvInPreviousState", hasMrvInPreviousState);

      return chips?.[0] ? (
        <ChipsTableCellComponent type="mrv" chips={chips} />
      ) : notRev0 && hasMrvInPreviousState ? (
        <Button variant="outlined" color="info">
          Update MRV
        </Button>
      ) : (
        ""
      );
    },
  },
  {
    accessorKey: "srvNumber",
    header: "SRV #",
    enableEditing: false,
    size: 70,
    Cell: ({ row }) => {
      let chips =
        row.original.srvMaterials?.map((m) => {
          return m?.srv;
        }) || [];

      const revs = row.original.drawingRevs || [];
      const sortedRevs = revs.sort((a, b) => a.revision - b.revision);
      const drawing = row.original.drawing || {};
      const index = sortedRevs.findIndex((rev) => rev.id === drawing?.id);
      const notRev0 = index > 0;
      const tagNumber = row.original.taggedMaterial?.tagNumber;

      // If no current SRV, check for inherited SRV from previous revisions
      if (!chips?.[0] && notRev0) {
        const latestSrv = findLatestRevisionWithData(
          sortedRevs,
          index,
          tagNumber,
          row.original,
          (material) => material?.srvMaterials?.map((m) => m?.srv) || null,
        );
        if (latestSrv) {
          chips = latestSrv;
        }
      }

      return <ChipsTableCellComponent type="srv" chips={chips} />;
    },
  },
  // {
  //   accessorKey: "balance",
  //   header: "Balance Qty Length",
  //   enableEditing: false,
  //   size: 70,
  //   Cell: ({ row }) => {
  //     return (
  //       <StockQtyInput
  //         row={row}
  //         name="estCost"
  //         placeholder="balance"
  //         defaultValue={row.original.estCost}
  //       />
  //     );
  //   },
  // },

  {
    accessorKey: "heatNumber",
    header: "Heat #",
    enableEditing: false,
    size: 70,
  },

  {
    accessorKey: "remarks",
    header: "Remarks",
    enableEditing: false,
    size: 30,
  },
];
